export const ActionTypes = {
  GET_MALLS: 'GET_MALLS',
  GET_STORES: 'GET_STORES',
  GET_STORES_NEW_USER: 'GET_STORES_NEW_USER',
  GET_STORE_GROUPS: 'GET_STORE_GROUPS',
};
